import styled from 'styled-components';
import { colors } from '@karnott/colors';
import { fontFamily, pixelSpacing } from '@karnott/theme';

/** The panel of the form popups: white background, light border and shadow */
export const PopupContent = styled.div`
  padding: ${pixelSpacing('small')};
  box-shadow:
    0 3px 10px rgba(0, 0, 0, 0.02),
    0 -3px 10px rgba(0, 0, 0, 0.02);
  border: 1px solid ${colors('grey', 200)};
  border-radius: ${pixelSpacing('xSmall')};
  background-color: ${colors('white')};
  font-family: ${fontFamily()};
  box-sizing: border-box;
`;
